import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export type DateRangeValue = {
  fromDate: string | null;
  toDate: string | null;
};

const DATE_RANGE_DISPLAY_FORMATS = {
  parse: {
    dateInput: { day: '2-digit', month: 'short', year: 'numeric' },
  },
  display: {
    dateInput: { day: '2-digit', month: 'short', year: 'numeric' },
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: '2-digit', month: 'long', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
  },
};

@Component({
  selector: 'app-date-range-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule],
  templateUrl: './date-range-filter.component.html',
  styleUrl: './date-range-filter.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_RANGE_DISPLAY_FORMATS }],
})
export class DateRangeFilterComponent {
  @Input() fromDateLabel = 'From Date';
  @Input() toDateLabel = 'To Date';
  @Input() fromDate: Date | null = null;
  @Input() toDate: Date | null = null;
  @Output() rangeChange = new EventEmitter<DateRangeValue>();

  onFromDateChange(value: Date | null): void {
    this.fromDate = value;
    if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
      this.toDate = this.fromDate;
    }
    this.emitRange();
  }

  onToDateChange(value: Date | null): void {
    this.toDate = value;
    if (this.fromDate && this.toDate && this.toDate < this.fromDate) {
      this.fromDate = this.toDate;
    }
    this.emitRange();
  }

  private emitRange(): void {
    this.rangeChange.emit({
      fromDate: this.toIsoDate(this.fromDate),
      toDate: this.toIsoDate(this.toDate),
    });
  }

  private toIsoDate(value: Date | null): string | null {
    if (!value) return null;
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
